import {
	MimaText,
	ReceiptCheckBox as RCB,
	FlexButton,
	MimaButton,
} from '../../components';
import styles from '../../assets/styles/BusinessAdmin/BusinessAdmin.module.scss';
import { Formik } from 'formik';
import React from 'react';
import { addIdFromArray, removeIdFromArray, groupTransactionsByParam } from '../../utils/utils';
import { toJS } from 'mobx';

const PermissionList = ({
	permissions,
	admin,
	availablePermissions,
	showPermissions,
	savePermissions,
	showSavedPermissions,
	onSubmit,
	loading,
}) => {

	const allPermisions = availablePermissions.flatMap(x => x.permissions);
	const givenPermissions = allPermisions.filter(
		x => admin?.user?.permissions?.find(y => x._id === y)
	);

	return (
		<Formik
			initialValues={{
				ids: givenPermissions || [],
				all: false,
			}}
			// validationSchema={validationSchema}
			onSubmit={onSubmit}
		>
			{({ handleSubmit, values, setFieldValue }) => (
				<>
					<MimaText variant="small" align="center" mb={1}>
						Set Permissions for
					</MimaText>

					<MimaText variant="bodyBold" align="center">{`${admin.user.firstname} ${admin.user.lastname}`}</MimaText>
					<MimaText variant="small" color="var(--color-primary)" align="center" mb={2}>{admin.jobTitle}</MimaText>

					{!savePermissions && (
						<>
							<MimaText variant="smallBold" align="center">
								Permissions list
							</MimaText>
							<div className={styles.ba__permits_middle}>
								<RCB
									title="Select All Permissions"
									onChange={() => {
										if (!values.all) {
											setFieldValue('ids', allPermisions);
											setFieldValue('all', !values.all);
										} else {
											setFieldValue('ids', []);
											setFieldValue('all', !values.all);
										}
									}}
									id={0}
									name={0}
									checked={values.all}
								/>
							</div>
							{availablePermissions.map((permit, i) => (
								<div key={permit.module}>
									<FlexButton
										title={permit.module}
										mt={1}
										onClick={() => showPermissions(i)}
									/>
									<div className={styles.ba__permits}>
										{permissions === i
											? permit.permissions.map((item, i) => (
												<RCB
													title={item.name}
													key={item._id}
													onChange={() => {
														const found = values.ids.find(
															x => x._id === item._id
														);
														if (found) {
															setFieldValue('all', false);
														}

														const ids = !found
															? addIdFromArray(values.ids, item)
															: removeIdFromArray(values.ids, item._id);
														setFieldValue('ids', ids);
													}}
													id={item._id}
													name={item._id}
													checked={values.ids.find(x => x._id === item._id)}
													value={item._id}
												/>
											))
											: ''}
									</div>
								</div>
							))}

							<MimaButton title="Save" onClick={showSavedPermissions} />
						</>
					)}
					{savePermissions ? (
						<>
							<MimaText variant="small" align="center" mb={3}>
								includes
							</MimaText>

							{groupTransactionsByParam(values.ids, "module").map((permit, i) => {
								return (
									<div key={permit.title}>
										<MimaText variant="smallBold" color="var(--color-primary)">
											{permit.title}
										</MimaText>

										<div className={styles.ba__permits_list}>
											{permit.data.map((item, i) => (
												<li key={item._id} >{item.name}</li>
											))}
										</div>
									</div>
								)
							})}

							<MimaButton title="Continue" onClick={handleSubmit} loading={loading} />
						</>
					) : null}
				</>
			)}
		</Formik>
	);
};

export default PermissionList;
